import disabledEmphasis from '../../../../text/disabled-emphasis';

const custom = (params) => disabledEmphasis(params);

export default custom;
